import { useState, useEffect } from 'react';
import React, { createContext, useContext } from 'react';
import axios from 'axios';
import { rootUrl } from '../../config/config';
const AuthContext = createContext();


export const AuthProvider = ({ children }) => {

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoggedInCheck, setIsLoggedInCheck] = useState(false);
    const [authToken, setAuthToken] = useState(localStorage.getItem('authToken'));
    const [user, setUser] = useState(null);
    const [impersonatedBy, setImpersonatedBy] = useState(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        isloggedin();
    }, []);

    const isloggedin = () => {

        const token = localStorage.getItem('authToken');
        if (!token) {
            console.log("Checking Logged In", isLoggedInCheck, isAuthenticated)
            setIsLoggedInCheck(true);
            return false;
        }
        try {
            if (isTokenExpired(token)) {
                setIsLoggedInCheck(true)
                refreshToken().catch(logout);
            } else {

                const decodedToken = JSON.parse(atob(token.split('.')[1]));
                const profilePicture = localStorage.getItem('cfms-profile-picture');
                const newUser = {
                    username: decodedToken.username || "Guest",
                    email: decodedToken.email || "Guest",
                    id: decodedToken.id || "N/A",
                    name: localStorage.getItem('cfms-name') || "John Doe",
                    profile_picture: profilePicture || null,
                    actor_type: decodedToken.actor_type || 'staff',
                    linked_entity_id: decodedToken.linked_entity_id || null,
                    linked_entity_code: decodedToken.linked_entity_code || null
                };
                // Restore impersonation state across page refresh
                setImpersonatedBy(decodedToken.impersonated_by || null);

                return Promise.resolve()
                    .then(() => {
                        const newAuth = true;
                        const newCheck = true;
                        setIsAuthenticated(newAuth);
                        setAuthToken(token);
                        setUser(newUser);
                        setIsLoggedInCheck(newCheck);

                        console.log(newUser)
                        return newAuth;

                    });
            }
        } catch (error) {
            setIsLoggedInCheck(true)
            console.error('Error checking login status:', error);
            return false;
        }


    };

    // Function to check if the token is expired
    const isTokenExpired = (token) => {
        try {
            const { exp } = JSON.parse(atob(token.split('.')[1]));
            const expired = Date.now() >= exp * 1000 - 300000; // 5 minutes before expiry
            return expired;
        } catch (error) {
            console.error('Error checking token expiration:', error);
            return true;
        }
    };

    const login = (accessToken, refreshToken, name, profilePicture = null) => {
        localStorage.setItem('authToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('cfms-name', name);
        if (profilePicture) {
            localStorage.setItem('cfms-profile-picture', profilePicture);
        }
        setAuthToken(accessToken);
        setIsAuthenticated(true);

        // Decode token to get user information 
        const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
        const username = decodedToken.username || "Guest"; // Handle missing username case
        //setUser({ decodedToken });
        setUser({
            username: decodedToken.username || "Guest",
            email: decodedToken.email || "Guest",
            id: decodedToken.id || "N/A",
            name: name || decodedToken.name || "John Doe", // prefer name from login()
            profile_picture: profilePicture || null,
            actor_type: decodedToken.actor_type || 'staff',
            linked_entity_id: decodedToken.linked_entity_id || null,
            linked_entity_code: decodedToken.linked_entity_code || null
        });


        console.log('Login: User information stored', { username });
    };

    const updateUserProfile = (userData) => {
        if (userData.profile_picture) {
            localStorage.setItem('cfms-profile-picture', userData.profile_picture);
        }
        setUser(prevUser => ({
            ...prevUser,
            ...userData
        }));
    };

    // useEffect(() => {

    //     const token = localStorage.getItem('authToken');

    //     if (token) {
    //         if (isTokenExpired(token)) {
    //             refreshToken().catch(logout);
    //         } else {
    //             setIsAuthenticated(true);
    //             setAuthToken(token);
    //             const decodedToken = JSON.parse(atob(token.split('.')[1]));
    //             const username = decodedToken.username || "Guest";
    //             const email = decodedToken.email || "Guest";
    //             const id = decodedToken.id || "N/A";
    //             setUser({ username, id, email });
    //             console.log('User information restored:', isAuthenticated, { username, id, email });
    //         }
    //     }
    // }, []);

    // Initial token check on component mount
    // useEffect(() => {
    //     console.log('useEffect for initial token check called');
    //     const token = localStorage.getItem('authToken');
    //     if (token) {
    //         if (isTokenExpired(token)) {
    //             console.log('useEffect: Token is expired, refreshing...');
    //             refreshToken().catch(logout);
    //         } else {
    //             setIsAuthenticated(true);
    //             setAuthToken(token);
    //             console.log('useEffect: Token is valid, user authenticated');
    //             // Decode token to get user information
    //             const decodedToken = JSON.parse(atob(token.split('.')[1]));
    //             setUser({ username: decodedToken.username, id: decodedToken.id, email: decodedToken.email });  // Only restore username

    //             console.log('useEffect: User information restored', { username: decodedToken.username });
    //         }
    //     }
    // }, []);


    // Interval for token refresh
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        console.log('Setting up interval for token refresh');
        const interval = setInterval(() => {
            const token = localStorage.getItem('authToken');
            if (token) {
                if (isTokenExpired(token)) {
                    console.log('Interval: Token is expired, refreshing...');
                    refreshToken().catch(logout);
                }
            }
        }, 10 * 60 * 1000); // Check every 10 minutes

        return () => clearInterval(interval);
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const token = authToken || localStorage.getItem('authToken');
        if (!isAuthenticated || !token) {
            return undefined;
        }

        let cancelled = false;

        const currentUser = user;
        if (currentUser?.actor_type && currentUser.actor_type !== 'staff') {
            return undefined;
        }

        const sendHeartbeat = async () => {
            try {
                await axios.post(
                    `${rootUrl}/api/presence/heartbeat`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
            } catch (error) {
                if (!cancelled) {
                    console.warn('Presence heartbeat failed:', error.message);
                }
            }
        };

        sendHeartbeat();
        const heartbeatInterval = setInterval(sendHeartbeat, 60000);

        return () => {
            cancelled = true;
            clearInterval(heartbeatInterval);
        };
    }, [authToken, isAuthenticated]);


    // Start impersonating a user — saves the admin session, then switches to the target
    const startImpersonation = (accessToken, name, profilePicture) => {
        // Persist current admin session so we can restore it later
        localStorage.setItem('cfms-admin-token', localStorage.getItem('authToken') || '');
        localStorage.setItem('cfms-admin-refresh', localStorage.getItem('refreshToken') || '');
        localStorage.setItem('cfms-admin-name', localStorage.getItem('cfms-name') || '');

        // Switch to impersonated session (no refresh token — 1-hour hard expiry)
        localStorage.setItem('authToken', accessToken);
        localStorage.removeItem('refreshToken');
        localStorage.setItem('cfms-name', name);
        if (profilePicture) {
            localStorage.setItem('cfms-profile-picture', profilePicture);
        }

        setAuthToken(accessToken);
        setIsAuthenticated(true);

        const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
        setImpersonatedBy(decodedToken.impersonated_by || null);
        setUser({
            username: decodedToken.username || 'Guest',
            email: decodedToken.email || 'Guest',
            id: decodedToken.id || 'N/A',
            name: name,
            profile_picture: profilePicture || null,
            actor_type: decodedToken.actor_type || 'staff',
            linked_entity_id: decodedToken.linked_entity_id || null,
            linked_entity_code: decodedToken.linked_entity_code || null
        });
    };

    // Stop impersonating — restore the original admin session
    const stopImpersonating = () => {
        const adminToken = localStorage.getItem('cfms-admin-token');
        const adminRefresh = localStorage.getItem('cfms-admin-refresh');
        const adminName = localStorage.getItem('cfms-admin-name');

        localStorage.removeItem('cfms-admin-token');
        localStorage.removeItem('cfms-admin-refresh');
        localStorage.removeItem('cfms-admin-name');

        if (adminToken) {
            localStorage.setItem('authToken', adminToken);
            if (adminRefresh) localStorage.setItem('refreshToken', adminRefresh);
            localStorage.setItem('cfms-name', adminName || '');

            setAuthToken(adminToken);
            setIsAuthenticated(true);
            setImpersonatedBy(null);

            const decodedToken = JSON.parse(atob(adminToken.split('.')[1]));
            setUser({
                username: decodedToken.username || 'Guest',
                email: decodedToken.email || 'Guest',
                id: decodedToken.id || 'N/A',
                name: adminName || decodedToken.name || 'Admin',
                profile_picture: localStorage.getItem('cfms-profile-picture') || null,
                actor_type: decodedToken.actor_type || 'staff',
                linked_entity_id: decodedToken.linked_entity_id || null,
                linked_entity_code: decodedToken.linked_entity_code || null
            });
        } else {
            logout();
        }
    };

    // Logout function
    const logout = () => {
        console.log('Logout function called');
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        setAuthToken(null);
        setIsAuthenticated(false);
        // mark that we've completed the logged-in check so routes can redirect
        setIsLoggedInCheck(true);
        setUser(null); // Clear user information
        console.log('Logout: Tokens removed and user cleared');
    };

    // Function to refresh token
    const refreshToken = async () => {
        try {
            const storedRefreshToken = localStorage.getItem('refreshToken');
            if (!storedRefreshToken) {
                console.error('No refresh token found');
                throw new Error('No refresh token found');
            }

            console.log('Sending refresh token:', storedRefreshToken);

            // Send the refresh token in the request body
            const response = await axios.post('/token', { token: storedRefreshToken });

            console.log('Response from server:', response);

            if (response.status === 200) {
                const { accessToken } = response.data;
                localStorage.setItem('authToken', accessToken);
                setAuthToken(accessToken);
                setIsAuthenticated(true);

                // Decode token to get user information
                const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
                const profilePicture = localStorage.getItem('cfms-profile-picture');
                const userDetails = {
                    username: decodedToken.username,
                    id: decodedToken.id,
                    email: decodedToken.email,
                    name: decodedToken.name,
                    profile_picture: profilePicture || null,
                    actor_type: decodedToken.actor_type || 'staff',
                    linked_entity_id: decodedToken.linked_entity_id || null,
                    linked_entity_code: decodedToken.linked_entity_code || null
                };
                setUser(userDetails);

                console.log('refreshToken: User information restored after refresh', userDetails);
            } else {
                throw new Error('Token refresh failed');
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            logout(); // Log out if token refresh fails
        }
    };


    useEffect(() => {
        console.log('AuthState: isAuthenticated changed to', isAuthenticated);
    }, [isAuthenticated]);

    // Axios request interceptor
    axios.interceptors.request.use(
        (config) => {
            // console.log('Request Interceptor called');
            const token = localStorage.getItem('authToken');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
                // console.log('Request Interceptor: Added Authorization header', token);
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Axios response interceptor
    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            // console.log('Response Interceptor called');
            const originalRequest = error.config || {};
            // Guard for cases where error.response may be undefined (network errors)
            const status = error.response && error.response.status;
            if (status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    await refreshToken();
                    const token = localStorage.getItem('authToken');
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    // console.log('Response Interceptor: Retrying request with new token', token);
                    return axios(originalRequest);
                } catch (refreshError) {
                    console.error('Error retrying request after token refresh failure:', refreshError);
                    logout(); // Logout if refresh token fails
                }
            }
            return Promise.reject(error);
        }
    );

    return (
        <AuthContext.Provider value={{ user, token: authToken, isAuthenticated, isLoggedInCheck, login, logout, updateUserProfile, isImpersonating: !!impersonatedBy, impersonatedBy, startImpersonation, stopImpersonating }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export { AuthContext };

